import { useLayoutStore } from "./pinia/layout";
import { useAuthFakeStore } from "./pinia/authFake";
import { useAuthStore } from "./pinia/auth";
import { useNotificationStore } from "./pinia/notification";
import { useCommonAppModule } from "./pinia/commonAppModule";
import { useLazyLoaderModule } from "./pinia/lazyloaderManagerModule";
import { useSimplepharmAuthModule } from "./pinia/simplepharmAuthModule";
import { useOrdersManagerModule } from "./pinia/ordersManagerModule";
import { usePackagesManagerModule } from "./pinia/packagesManagerModule";
import { usePaymentsManagerModule } from "./pinia/paymentsManagerModule";
import { usePricesManagerModule } from "./pinia/pricesManagerModule";
import { useReportsManagerModule } from "./pinia/reportsManagerModule";
import { useCommonImportModule } from "./pinia/commonImportModule";
import { useCommonExportModule } from "./pinia/commonExportModule";
import { useUserRbacManagerModule } from "./pinia/userRbacManagerModule";
import { useUserProfileModule } from "./pinia/userProfileModule";

import { createPinia } from "pinia";

const pinia = createPinia();
export default pinia;

export {
    useLayoutStore,
    useNotificationStore,
    useLazyLoaderModule,
    useAuthFakeStore,
    useAuthStore,
    useCommonAppModule,
    useSimplepharmAuthModule,
    useOrdersManagerModule,
    usePackagesManagerModule,
    usePaymentsManagerModule,
    usePricesManagerModule,
    useReportsManagerModule,
    useCommonImportModule,
    useCommonExportModule,
    useUserRbacManagerModule,
    useUserProfileModule
};
